module.exports = __webpack_public_path__ + "static/How-to-Relieve-a-Tension-Headache-Without-Medication-a433404f5b7d985ee8e0f5e1d05e134d.webp";